import React, { useEffect } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { CategoryBar } from './components/CategoryBar';
import { ProductsSection } from './components/ProductsSection';
import { TradingSection } from './components/TradingSection';
import { MomentumSection } from './components/MomentumSection';
import { StepsSection } from './components/StepsSection';
import { ReferralSection } from './components/ReferralSection';
import { MobileSection } from './components/MobileSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { StickyMobileCta } from './components/StickyMobileCta';
import { trackEvent } from './utils/tracking';
export function App() {
  useEffect(() => {
    trackEvent('page_view', {
      page_title: 'Bybit · Landing de referido'
    });
    trackEvent('view_content', {
      content_name: 'bybit_referral_landing'
    });
  }, []);
  return <div className="min-h-full w-full bg-base font-sans text-white" data-id="element-0" data-mp="3iiweam7rne26">
      <a href="#top" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[60] focus:rounded-full focus:bg-brand focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-black" data-id="element-1" data-mp="3mlavz2zp87rv">
        Ir al contenido
      </a>

      <Header data-id="element-2" data-mp="7suzhf7pr6a" />

      <main data-id="element-3" data-mp="2zld1d7i6tbah">
        <Hero data-id="element-4" data-mp="2zllduyaeeel5" />
        <CategoryBar data-id="element-5" data-mp="2zm4ywnvchj3e" />
        <ProductsSection data-id="element-6" data-mp="2zmo5j8fjol24" />
        <TradingSection data-id="element-7" data-mp="2zng32ospcsv1" />
        <MomentumSection data-id="element-8" data-mp="33m5b01uz1i7a" />
        <StepsSection data-id="element-9" data-mp="33nq921ghvj9w" />
        <ReferralSection data-id="element-10" data-mp="33mykhalbelt4" />
        <MobileSection data-id="element-11" data-mp="38lrnua6w0wfk" />
        <FaqSection data-id="element-12" data-mp="38l8eviz7tido" />
        <FinalCta data-id="element-13" data-mp="38l03xwmnkn54" />
      </main>

      <Footer data-id="element-14" data-mp="38nuqput52k1p" />
      <StickyMobileCta data-id="element-15" data-mp="3dkuufz2inapn" />
    </div>;
}